import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.string.includes.js";
import { useArticles } from "@faire/help-center-utils/hooks/article/useArticles";
import { getBrand } from "@faire/help-center-utils/serialized-data/getBrand";
import { getSettingAdyenEligibleCountries } from "@faire/help-center-utils/settings/getSettingAdyenEligibleCountries";
export var usePaymentPayoutsArticles = function usePaymentPayoutsArticles() {
  var articles = useArticles();
  var brand = getBrand();
  if (!brand || !brand.based_in) {
    return [];
  }
  if (getSettingAdyenEligibleCountries().includes(brand.based_in)) {
    if ((brand === null || brand === void 0 ? void 0 : brand.based_in) === "AUS") {
      return [articles.InvoicesAndBilling.PAYOUT_AUSTRALIAN];
    }
    return [articles.InvoicesAndBilling.PAYOUT_EUROPEAN];
  } else if ((brand === null || brand === void 0 ? void 0 : brand.based_in) === "CAN") {
    return [articles.InvoicesAndBilling.PAYOUT_CANADIAN];
  } else {
    return [articles.InvoicesAndBilling.SETTING_UP_PAYOUT];
  }
};